<template>
  <div>
    <h2>Reset your password</h2>
    <form>
      <password-input
        :auto-focus="true"
        :value="password"
        label="New password"
        @input="password = $event"
      />
      <text-input
        :value="passwordConfirmation"
        placeholder="One more time"
        label="Confirm password"
        name="confirm-password"
        type="password"
        :error="!doPasswordsMatch"
        validation-message="Your passwords don't match"
        @input="passwordConfirmation = $event"
        @enter="resetPassword"
      />
      <loading-button
        :disabled="!isValidPassword || !doPasswordsMatch"
        :loading="loading"
        @click="resetPassword"
      >
        Reset password
      </loading-button>
    </form>
  </div>
</template>

<script>
import { LoadingButton, TextInput } from '@inscribe/ui-kit';
import { isValidPassword } from '../utils/validation';
import PasswordInput from './PasswordInput';

export default {
  components: {
    'loading-button': LoadingButton,
    'text-input': TextInput,
    'password-input': PasswordInput,
  },
  props: {
    passwordResetHash: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
      password: '',
      passwordConfirmation: '',
    };
  },
  computed: {
    isValidPassword() {
      return isValidPassword(this.password);
    },
    doPasswordsMatch() {
      return this.password === this.passwordConfirmation;
    },
  },
  methods: {
    resetPassword() {
      if (this.isValidPassword && this.doPasswordsMatch) {
        const data = new FormData();
        data.append('password', this.password);
        data.append('password_confirmation', this.passwordConfirmation);
        this.loading = true;
        this.$store
          .dispatch('resetPassword', {
            passwordResetHash: this.passwordResetHash,
            data,
          })
          .then((response) => {
            this.loading = false;
            this.$notify({
              group: 'general',
              type: 'success',
              title: 'Success!',
              duration: 5000,
              text: 'Password reset successfully. Please login',
            });
            this.$router.push({
              name: 'login',
            });
          })
          .catch((error) => {
            this.loading = false;
            this.$notify({
              group: 'general',
              type: 'error',
              title: 'There was a problem while resetting your password',
              duration: 5000,
              text: error.response.data.message,
            });
          });
      }
    },
  },
};
</script>
